import { createRouter, createWebHistory } from "vue-router";

import HomePage from "./HomePage.vue";
import RandomPick from "./pages/RandomPick.vue";
import NotFound from "./pages/NotFound.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: HomePage },
    { path: "/random", component: RandomPick },

    { path: "/:notFound(.*)", component: NotFound },
  ],
});

export default router;
